import { EnvironmentProviders, importProvidersFrom } from '@angular/core';
import { AuditTrailModule } from '@iot-platform/audit-trail';
import { AuditTrailService } from './audit-trail.service';
export { TrackingSettingsProviderService } from './tracking-settings-provider.service';

// Provide kercom audit trail settings for the application
export const provideKercomAuditTrailSettings = (): EnvironmentProviders =>
  importProvidersFrom(
    AuditTrailModule.forRoot({
      auditTrailService: AuditTrailService,
      exportLogDetails: true
    })
  );
